export enum ActivityStatus {
  Adjustment = 1,
  Transfer = 2,
  New = 3,
  Buy = 4,
  Sell = 5,
}
